exports.wrapRootElement = require('./src/components/Root').default
